<template>
  <footer class="app-rodape" :class="{ 'app-rodape--inter': isInterTheme }">
    <div class="app-rodape__conteudo">
      <RodapeSobreAcerto class="app-rodape__sobre" />
      <RodapeRecomendados class="app-rodape__recomendados" />
      <div class="app-rodape__coluna-lateral">
        <RodapeAlerta />
        <RodapeRedesSociais v-if="!isInterTheme" />
      </div>
    </div>
    <RodapeSeguranca />
  </footer>
</template>

<script setup lang="ts">
import RodapeAlerta from '@shared/rodape/components/RodapeAlerta/RodapeAlerta.vue';
import RodapeRecomendados from '@shared/rodape/components/RodapeRecomendados/RodapeRecomendados.vue';
import RodapeRedesSociais from '@shared/rodape/components/RodapeRedesSociais/RodapeRedesSociais.vue';
import RodapeSeguranca from '@shared/rodape/components/RodapeSeguranca/RodapeSeguranca.vue';
import RodapeSobreAcerto from '@shared/rodape/components/RodapeSobreAcerto/RodapeSobreAcerto.vue';
import theme from '@/services/ThemeService';

const isInterTheme = theme.isInterTheme();
</script>

<style scoped lang="scss">
@use "@/assets/styles/vars" as *;

.app-rodape {
  padding-top: 50px;
  background: var(--acerto-menu-bg, #fff);
  box-shadow: inset 0 3px 0 var(--acerto-menu-border-color);

  // No Inter o `--acerto-menu-bg` é laranja: o rodapé fica com o branco do tema Acerto.
  &.app-rodape--inter {
    background: var(--neutral-FF, #fff);
  }
}

.app-rodape__conteudo {
  display: flex;
  flex-direction: column;
  gap: $space-md;
  padding: $space-sm $space-xs;

  @include responsive($desktop) {
    display: grid;
    grid-template-columns: 1.6fr 1fr 1fr;
    gap: $space-md;
    align-items: start;
    // Mesmas guias da `.navigation-bar` (AppHeader.vue): alinha com a logo e o botão Sair.
    @include shell-aligned-padding;
    padding-top: $space-lg;
    padding-bottom: $space-lg;
  }
}

.app-rodape__coluna-lateral {
  display: flex;
  flex-direction: column;
  gap: $space-xs;
}
</style>
